import {Theme, alpha} from "@mui/material";
import {makeStyles} from "tss-react/mui";

export const useStyles = makeStyles<void, "sectionMenu">()((theme: Theme, _params, classes) => ({
    row: {
        backgroundColor: alpha(theme.palette.background.default, 0.7),
    },
    sectionRow: {
        "& > td": {
            position: "relative",
        },
    },
    sectionDivider: {
        visibility: "hidden",
        margin: 0,
        transition: "margin 0.2s",
    },
    activeDivider: {
        visibility: "visible",
        margin: "10px 0",
    },
    sectionMenu: {
        color: theme.palette.primary.main,
        transition: "opacity 0.4s",
        opacity: 0.01,
        position: "absolute",
        right: -24,
        top: -12,
        cursor: "pointer",
        "&:hover": {
            opacity: "0.7 !important",
        },
    },
    activeSectionMenu: {
        top: -3,
    },
    sectionEnd: {
        "& > td": {
            borderBottom: "1px solid " + theme.palette.divider,
        },
    },
    actionCell: {
        textAlign: "center",
    },
    disabled: {
        pointerEvents: "none",
        opacity: 0.4,
    },
    header: {
        "& > td": {
            fontWeight: "bold",
            fontSize: "1.1em",
            whiteSpace: "nowrap",
            borderBottom: "1px solid " + theme.palette.divider,
            padding: 5,
        },
    },
    noMembersContainer: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        justifyContent: "space-between",
        marginTop: 3,
    },
    container: {
        display: "flex",
        flexDirection: "column",
        width: "fit-content",
        paddingLeft: 20,
        paddingRight: 30,
        [`&:hover .${classes.sectionMenu}`]: {
            opacity: 0.1,
        },
    },
    formActionButtons: {
        display: "flex",
        justifyContent: "center",
        marginTop: "1em",
    },
}));
